export default __webpack_public_path__ + "static/media/awardWinner.95ab8888.jpg";